define('utils/declOfNum', [
    'jquery'
],  function ($) {
    'use strict';

    console.log('%cfile: declOfNum.js', 'color: #C2ECFF');

    var declOfNum = function declOfNum(){
        console.log('%ctrace: declOfNum', 'color: #ccc');

        var el = '[data-declOfNum]',
            count = '[data-declOfNum-count]',
            words = '[data-declOfNum-words]',
            cases = [2, 0, 1, 1, 1, 2];

        var $el = $(el);

        if($el.length <= 0){
            console.warn('%ctrace: declOfNum: not found dom elements', 'color: #ccc');
            return false;
        }

        $el.each(function(i, el){
            initialize($(el));
        });

        function initialize($el){
            var count = parseInt($('[data-declOfNum-count="' + $el.attr('data-declOfNum') + '"]').html(), 10),
                words = $el.attr('data-declOfNum-words').split(','),
                word;

            /*https://gist.github.com/realmyst/1262561*/
            word = words[(count%100>4 && count%100<20)? 2 : cases[(count%10<5)?count%10:5]];

            $el.html(word);
        }
    };

    return declOfNum;
});

